import request from '../../../helpers/request';

const createMeter = async (formValues) => {
  return await request.post(
    '/RentPlace/meter',
    formValues,
    'При создании счетчика произошла ошибка'
  );
};

export default createMeter;
